import { render, staticRenderFns } from "./ThirdPartyBinding.vue?vue&type=template&id=4b13cc4e&scoped=true&"
import script from "./ThirdPartyBinding.vue?vue&type=script&lang=ts&"
export * from "./ThirdPartyBinding.vue?vue&type=script&lang=ts&"
import style0 from "./ThirdPartyBinding.vue?vue&type=style&index=0&id=4b13cc4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b13cc4e",
  null
  
)

export default component.exports